import { genTitleCreativeByAssistant } from 'helpers';
import { correctBodyToRequest } from 'helpers/request';
import { isArray } from 'lodash';

// const removePrefixEachMsg = (msg = '') => {
//   return msg
//     .replace(/^\d+\./g, '')
//     .replace(/^\d+:/g, '')
//     .replace(/^\d+\)/g, '')
//     .replace(/^Message.[0-9]+?:/g, '')
//     .trim();
// };

class CreativeModel {
  static parseRequestSearchCreatives(filters) {
    const nextFilters = correctBodyToRequest(filters);
    return {
      message: nextFilters?.message || '',
      title: nextFilters?.title || '',
      offset: nextFilters?.offset || 0,
      limit: nextFilters?.limit || 50,
      sortBy: nextFilters?.sortBy || '',
      sortDirection: nextFilters?.sortDirection || '',
      routeId: nextFilters?.routeId || undefined,
      approvalStatus: nextFilters?.approvalStatus || undefined,
    };
  }

  static parseRequestCreateOrUpdateCreative(body) {
    const nextBody = correctBodyToRequest(body);
    return {
      id: nextBody?.id || undefined,
      title: nextBody?.title || '',
      message: nextBody?.message || '',
      routeId: nextBody?.routeId,
      countries: nextBody?.countries || [],
      voice: nextBody?.voice || undefined,
    };
  }

  static parseHistoryAssistantToCreative(historyAssistant = {}) {
    const rawAnswer = String.raw`${historyAssistant?.answer}`;
    //* Remove label Multiline:
    //* SMS 1: / Message 1: / Message number 1: \n
    //* abc xyz
    const nextRawAnswer = rawAnswer
      .replace(/SMS \d+:/gm, '')
      .replace(/SMS message \d+:/gm, '')
      .replace(/SMS Message \d+:/gm, '')
      .replace(/Message \d+:$/gm, '');
    const listAnswer = nextRawAnswer.split('\n');

    if (isArray(listAnswer)) {
      const result = listAnswer
        .map((el, idx) => {
          return {
            title: `${genTitleCreativeByAssistant(historyAssistant)}`,
            message: el,
          };
        })
        .map((el) => ({
          ...el,
          message: el.message.trim(),
        }))
        .filter((el) => !!el.message)
        .map((elm, index) => {
          return {
            title: elm.title + '_' + (index + 1 < 10 ? `0${index + 1}` : index + 1),
            message: elm.message,
          };
        });
      // //* Filter the case " on start and " on end string
      // .map((el) => {
      //   if (el.message.charAt(0) === `"` && el.message.charAt(el.message.length - 1) === `"`) {
      //     return {
      //       ...el,
      //       message: el.message.slice(1, el.message.length),
      //     };
      //   }

      //   return el;
      // });

      return result;
    }

    return [];
  }
}

export default CreativeModel;
